import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import { ConstructionMaterialSupplier } from '@client/features/material-catalog/models/construction-material-supplier';

export class ConstructionMaterialSupplierDataSource extends DataSource {
  async findAll(ownerId: number): Promise<ConstructionMaterialSupplier[]> {
    const response = await this.httpClient.get<HttpResponse<ConstructionMaterialSupplier[]>>(
      `/workspace/${ownerId}/construction-material-suppliers`,
    );

    return response.data.data.map((supplier) => fromJson(ConstructionMaterialSupplier, supplier));
  }
}
